import { render, staticRenderFns } from "./CustomOfficeViewer.vue?vue&type=template&id=214cd1c0&"
import script from "./CustomOfficeViewer.vue?vue&type=script&lang=js&"
export * from "./CustomOfficeViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports